import {
    FC,
    ReactElement,
    useEffect,
} from 'react'
import { useNavigate } from 'react-router'

import { ZeroState } from '@/components'
import { TrackListItem } from '@/compositions'
import { ConnectedDateNavigator } from '@/connectors'
import { trans } from '@/helpers/trans'
import { TrackResource } from '@/models'
import { useTypedDispatch, useTypedSelector } from '@/redux/store'
import { getTracksForMe } from '@/redux/tracks/tracksActions'

import './TracksPage.scss'

export const TracksPage: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const navigate = useNavigate()
    const { tracks } = useTypedSelector(state => state.tracksReducer)
    const { loading } = useTypedSelector(state => state.appReducer)

    const fetchTracks = (): void => {
        dispatch(getTracksForMe())
    }

    useEffect(fetchTracks, [])

    const handleTrackClick = (track: TrackResource): void => {
        navigate(`/${trans('nav.tracks.link')}/${track.id}`, { state: { track } })
    }

    return (
        <>
            <ConnectedDateNavigator onAfterDateChange={fetchTracks} />

            <ul>
                {tracks.length > 0 && ! loading ? tracks.map(track => (
                    <TrackListItem
                        key={track.id}
                        track={track}
                        onClick={() => handleTrackClick(track)}
                        className="tracks__list-item"
                    />
                )) : (
                    <ZeroState
                        text={trans('pages.tracks.emptyList')}
                        className="tracks__zero-state"
                    />
                )}
            </ul>
        </>
    )
}
